<template>
  <div style="padding-bottom: 5px; background-color: white">
    <div style="display: flex; align-items: center" @click="toggleCollapse">
      <v-icon> {{ isCollapsed ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
      <button style="padding: 10px; text-align: justify">
        {{ pergunta }}
      </button>
    </div>

    <div v-if="isCollapsed">
      <div v-if="!(visualizar && !sm)">
        <div
          v-for="n in quantidade"
          :key="n"
          :style="{ borderLeft: '5px solid ' + cores[n - 1] }"
          style="
            border-bottom: 1px solid #e6e6e6;
            border-top: 1px solid #e6e6e6;
          "
        >
          <div
            style="
              align-items: center;
              display: flex;
              padding-top: 5px;
              padding-bottom: 5px;
            "
          >
            <h6 style="margin-left: 5%; margin-right: 5%; font-size: 15px">
              {{ n }}
            </h6>
            <div style="width: 40%">
              <p v-if="!visualizar" style="font-size: 15px">
                {{ nomeMembros[n - 1] }}
              </p>
              <p v-if="sm" style="font-size: 15px">
                {{ nomeMembros[n - 1] }}
              </p>
            </div>
            <div v-if="!visualizar" style="margin-left: 5%">
              <label v-for="num in 11" :key="num" style="margin-right: 20px">
                <input
                  type="radio"
                  :value="num - 1"
                  v-model="selectedNumber[n - 1]"
                  @change="handleRadioChange(n - 1)"
                />
                {{ num - 1 }}
              </label>
            </div>
            <p v-if="visualizar && sm">{{ notasRecebidas[n - 1] }}</p>
          </div>
        </div>
      </div>

      <div
        v-if="visualizar && !sm"
        :style="{ borderLeft: '5px solid ' + cores[0] }"
        style="border-bottom: 1px solid #e6e6e6; border-top: 1px solid #e6e6e6"
      >
        <div
          style="
            align-items: center;
            display: flex;
            padding-top: 5px;
            padding-bottom: 5px;
          "
        >
          <div style="width: 80%">
            <p v-if="visualizar" style="font-size: 15px; margin-left: 5%">
              <b>Como me avaliei</b>
            </p>
          </div>
          <p style="font-size: 15px; margin-left: 5%">
            {{ autoAvaliacao.toFixed(2) }}
          </p>
        </div>
      </div>
      <div
        v-if="visualizar && !sm"
        :style="{ borderLeft: '5px solid ' + cores[0] }"
        style="border-bottom: 1px solid #e6e6e6; border-top: 1px solid #e6e6e6"
      >
        <div
          style="
            align-items: center;
            display: flex;
            padding-top: 5px;
            padding-bottom: 5px;
          "
        >
          <div style="width: 80%">
            <p v-if="visualizar" style="font-size: 15px; margin-left: 5%">
              <b>Como fui avaliado</b>
            </p>
          </div>
          <p style="font-size: 15px; margin-left: 5%">{{ media.toFixed(2) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notasRecebidas: {
      type: Array,
      required: false,
      default: () => [],
    },
    titulo: {
      type: String,
      required: false,
      default: () => '',
    },
    visualizar: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    sm: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    pergunta: {
      type: String,
      required: true,
    },
    quantidade: {
      type: Number,
      required: true,
    },
    posicao: {
      type: Number,
      required: true,
    },
    nomeMembros: {
      type: Array,
      required: false,
      default: () => [],
    },
    fotosMembros: {
      type: Array,
      required: false,
      default: () => [],
    },
    notasDadas: {
      type: Array,
      required: false,
      default: () => [],
    },
    autoAvaliacao: {
      type: Number,
      required: false,
      default: () => 0,
    },
  },
  created() {
    for (var i = 0; i < this.quantidade; i++) {
      this.selectedNumber.push(0);
    }
    this.notasDadasEnvia = this.notasDadas;
    var cont = 0;
    this.notasRecebidas.forEach((nota) => {
      this.media += nota;
    });
    this.media = this.media / this.notasRecebidas.length;
    if (isNaN(this.media)) {
      this.media = 0;
    }
    if (this.nomeMembros.length > 5) {
      this.nomeMembros.forEach(() => {
        this.cores.push(this.cores[cont]);
        cont++;
        if (cont == 5) {
          cont = 0;
        }
      });
    }
  },
  data() {
    return {
      media: null,
      cores: [
        '#ffa500',
        '#008000',
        '#9400d3',
        '#37b7e2',
        '#ff0000',
        '#ffa500',
        '#008000',
        '#9400d3',
        '#37b7e2',
        '#ff0000',
        '#ffa500',
        '#008000',
        '#9400d3',
        '#37b7e2',
        '#ff0000',
      ],
      selectedOptions: null,
      notasDadasEnvia: null,
      isCollapsed: false, // Estado inicial do colapso
      notas: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      selectedNumber: [],
    };
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    handleRadioChange(n) {
      this.notasDadasEnvia[n] = this.selectedNumber[n];
      this.$emit('retorna-ao-pai', [this.notasDadasEnvia, this.posicao]);
    },
    // handleOptionSelected(option) {
    //   this.notasDadasEnvia[option[1]] = option[0];
    //   this.$emit('retorna-ao-pai', [this.notasDadasEnvia, this.posicao]);
    // },
  },
};
</script>
